import React, { useState, useRef } from 'react';
import './UploadFile.css';
import uploadFilesIcon from '../../assets/upload-files-icon.png';
import downloadTemplateIcon from '../../assets/download-template-icon.png';
import lightbulbIcon from '../../assets/lightbulb-icon.png';

// File upload component with drag-and-drop support and template download
function UploadFile({ onFileSelect }) {
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragOver(false);
    const droppedFiles = event.dataTransfer.files;
    handleFiles(droppedFiles);
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    handleFiles(selectedFiles);
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Process selected files and reset input
  const handleFiles = (fileList) => {
    const filesArray = Array.from(fileList);
    onFileSelect(filesArray);
    resetFileInput();
  };

  // Download census template CSV
  const downloadTemplate = () => {
    const link = document.createElement('a');
    link.href = 'https://guidantassets.blob.core.windows.net/public/census-template.csv';
    link.download = 'census-template.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openSupportedReports = () => {
    window.open('https://support.guidantfinancial.com/supported-payroll-providers/', '_blank');
  };

  return (
    <div className="upload-file-container">
      <div className="upload-options">
        <div className="option">
          <div className="option-title">Option A: Complete and Upload Guidant's Template</div>
          <div className="download-template" onClick={downloadTemplate}>
            <img src={downloadTemplateIcon} alt="Download Template Icon" className="download-icon" />
            <span>DOWNLOAD TEMPLATE</span>
          </div>
        </div>

        <div className="option">
          <div className="option-title">Option B: Upload Supported Reports from ADP, Paychex, or Quickbooks Online</div>
          <div className="learn-about-reports" onClick={openSupportedReports}>
            <img src={lightbulbIcon} alt="Lightbulb Icon" className="lightbulb-icon" />
            <span>LEARN ABOUT SUPPORTED REPORTS</span>
          </div>
        </div>
      </div>

      <div
        className={`file-upload-area ${dragOver ? 'drag-over' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <img src={uploadFilesIcon} alt="Upload Files Icon" className="upload-icon" />
        <div className="upload-text">
          Drag and drop files here or <span className="browse-link">browse</span>
        </div>
        <div className="file-types">
          <span className="file-types-heading">Supported File Types:</span> Guidant .csv template or<br />
          supported ADP / Paychex / QBO reports<br />
          <br />
          Maximum File Size: 50MB
        </div>
        <input
          type="file"
          accept=".pdf,.docx,.doc,.txt,.csv,.xlsx, .xls"
          multiple
          onChange={handleFileChange}
          className="file-input"
          ref={fileInputRef}
        />
      </div>
    </div>
  );
}

export default UploadFile;